const isMobile = !!navigator.userAgent.match(/iPhone|Android/);
const isApp = !!navigator.userAgent.match(/maikuru_app/);
const isIPhone = !!navigator.userAgent.match(/iPhone/);
const isIPhoneApp = isIPhone && isApp;
const isPc = !isMobile;
export { isMobile, isPc, isIPhone, isIPhoneApp, isApp };
